import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { RootState } from "..";
import { State } from "../state";

/**
 * Enthält States, die in der ganzen App sichtbar sein sollen.
 */
export const appSlice = createSlice({
    name: "app",
    initialState: {
        isLoading: false,
        isCookieBannerOpen: false,
    } as State.App,
    reducers: {
        /**
         * Öffnet oder schließt den Menu-Drawer.
         */
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },

        /**
         * Öffnet oder schließt den Cookie-Banner.
         */
        setIsCookieBannerOpen: (state, action: PayloadAction<boolean>) => {
            state.isCookieBannerOpen = action.payload;
        },
    },
});

export const { setIsLoading, setIsCookieBannerOpen } = appSlice.actions;

export const useAppSlice = () => useSelector((state: RootState) => state.app);

export default appSlice.reducer;
